import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'button-assign',
  templateUrl: './button-assign.component.html',
  styleUrls: ['./button-assign.component.scss']
})
export class ButtonAssignComponent implements OnInit {
  @Output() eventClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  Assign() {
    this.eventClick.emit();
  }
}
